import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import { Container, Box, Button } from '@material-ui/core';
const ErrorMessageDialog = props => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Box, {
    style: {
      minHeight: 60
    }
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    value: props.message
  }), /*#__PURE__*/React.createElement(Box, {
    style: {
      textAlign: 'center',
      marginTop: 30,
      minHeight: 60
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "default",
    onClick: props.onClick
  }, "Inapoi"))));
};
ErrorMessageDialog.propTypes = {
  message: PropTypes.string,
  onClick: PropTypes.func
};
export default ErrorMessageDialog;